module.exports = __webpack_public_path__ + "img/TN.d77b4aec.svg";